import { render, staticRenderFns } from "./BottomNavBar.vue?vue&type=template&id=f3794342&scoped=true"
import script from "./BottomNavBar.vue?vue&type=script&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&lang=js"
import style0 from "./BottomNavBar.vue?vue&type=style&index=0&id=f3794342&prod&lang=scss"
import style1 from "./BottomNavBar.vue?vue&type=style&index=1&id=f3794342&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3794342",
  null
  
)

export default component.exports